<template>
  <div class="bg">
    <NavBar
      class="nav-bar"
      :placeholder="true"
      :options="options"
      title="邀请码填写"
      :zIndex="10"
    >
    </NavBar>
    <div class="content">
      <div class="input-content">
        <input
          class="input"
          type="text"
          v-model="text"
          placeholder="请将邀请码粘贴至此处"
        />
        <div class="tips" v-if="tips"
          ><img
            class="icon-image"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/68073bc1390eebfaadb9cd4a6444c9c7.png"
            alt=""
          />{{ tips }}</div
        >
      </div>
      <div
        class="btn"
        :class="{ 'btn-disabled': text === '' }"
        @click="bindClick"
        >确认</div
      >
    </div>
    <van-overlay :show="show" @click.stop="show = false" z-index="99">
      <div class="wrapper" @click.stop v-if="info">
        <img
          :src="info.jump_img"
          class="toast-image"
          alt=""
          @click="bindJump(info)"
        />
        <div class="close iconfont icon-cha" @click="show = false"></div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import NavBar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    NavBar
  },
  data() {
    return {
      options: {
        barBackgroundColor: '#ffffff',
        color: 'rgba(0,0,0,0.8)'
      },
      text: '',
      tips: '',
      show: false,
      disabledSubmit: false,
      info: null
    }
  },
  watch: {},
  methods: {
    bindClick() {
      if (this.disabledSubmit) {
        return
      }
      if (!this.text) {
        this.tips = '请输入邀请码'
        return
      }
      this.disabledSubmit = true
      this.$toast.loading('')
      let params = {
        invitation_code: this.text
      }
      this.$http
        .postApp('api/v1/ActivitySys/receive2', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.tips = ''
            this.info = res.data.jump_data
            this.show = true
          } else {
            this.tips = res.msg
          }
        })
        .catch(() => {})
        .finally(() => {
          this.disabledSubmit = false
          this.$toast.clear()
        })
    },
    bindJump(info) {
      this.$betterwe.jumpRoute(info.jump_url)
    }
  }
}
</script>
<style lang="scss" scoped>
.bg {
  overflow: hidden;
  min-height: 100vh;
  background: #ffffff;

  .content {
    text-align: center;
    margin-top: 97px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .input-content {
      position: relative;
      margin-bottom: 37px;

      .tips {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #ff5363;
        line-height: 16px;
        width: 100%;
        box-sizing: border-box;
        padding: 5px 5px 16px;
        position: absolute;
        left: 50%;
        bottom: 100%;
        transform: translate(-50%, 0%);
        display: flex;
        align-items: center;
        justify-content: center;

        .icon-image {
          width: 12px;
          height: 12px;
          object-fit: contain;
          margin-right: 4px;
        }
      }
    }

    .input {
      text-align: center;
      padding: 5px 10px;
      box-sizing: border-box;
      width: 343px;
      height: 56px;
      background: rgba(241, 241, 243, 0.8);
      border: none;
      border-radius: 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #acacac;
      line-height: 46px;
    }

    .input::placeholder {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #acacac;
      line-height: 46px;
    }

    .btn {
      width: 283px;
      height: 48px;
      border-radius: 24px;
      border: 1px solid #6236ff;
      box-sizing: border-box;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #6236ff;
      line-height: 46px;
    }

    .btn-disabled {
      border: 1px solid #acacac;
      color: #acacac;
    }
  }
}

.wrapper {
  border-radius: 8px;
  position: absolute;
  left: 50%;
  top: 26%;
  transform: translate(-50%, 0%);
  width: 295px;

  .toast-image {
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
  }

  .close {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #fff;
    color: #fff;
    position: absolute;
    left: 50%;
    bottom: -16px;
    transform: translate(-50%, 100%);
  }
}
</style>
